import { EOrganizedBy } from 'detailsv2/structure';
import yup from 'utils/yup';

export const infoValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    data: yup.object().shape({
      title: yup.string().required('Title is required'),
    }),
    attachedPages: yup.array().min(1, 'Please add a Page'),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};
